module.exports = "https://s91588.cdn.ngenix.net/home/_next/static/images/variant-b-credits-rating-fdd236bb6db3902dce1493f34f7dff80.png";